import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import cn from 'clsx'

const Container = styled.div`
  max-width: ${rem(328)};
  display: grid;
  grid-template-columns: [border-start] var(--gutter) [content-start] 1fr [content-end] var(--gutter) [border-end];
  grid-template-rows: [label-start] auto [border-start] auto [label-end] var(--top-gutter) [content-start] 1fr [content-end] var(--gutter) [border-end];

  &.size-small {
    --gutter: ${rem(8)};
    --top-gutter: ${rem(4)};
  }

  &.size-medium {
    --gutter: ${rem(16)};
    --top-gutter: ${rem(8)};
  }
`

const LabelContainer = styled.div`
  grid-column: border;
  grid-row: label;
`

const Border = styled.div`
  grid-column: border;
  grid-row: border;
  border: 1px solid ${props => props.theme.palette.product.loyalty};
  border-radius: ${props => props.theme.borderRadius.S};
`

const Content = styled.div`
  grid-column: content;
  grid-row: content;
`

interface Props {
  children: React.ReactNode;
  labels: React.ReactNode;
  size?: 'small' | 'medium';
  className?: string;
}

function LuxuryPlusLabeledContainer(props: Props) {
  const { children, labels, size = 'medium', className, ...rest } = props

  return (
    <Container className={cn(
      className,
      `size-${size}`,
    )} {...rest}>
      <Border aria-hidden="true" />
      <LabelContainer>
        {labels}
      </LabelContainer>
      <Content>{children}</Content>
    </Container>
  )
}

export default LuxuryPlusLabeledContainer
